module.exports = __webpack_public_path__ + "img/1-largo.633f2aff.jpg";